import React, { useState, useEffect } from 'react';
import { useStore, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createCallingScript, editCallerScriptOfPartner } from '../../redux/actions/caller';
import CheckboxComponent from '../CommonComponents/CheckboxComponent';
import LoaderComponent from '../CommonComponents/LoaderComponent';
import { toast } from '../CommonComponents/ToastComponent/toast';
import { MdOutlineArrowBackIosNew } from 'react-icons/md';
import { Modal, Tooltip, Whisper } from 'rsuite';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { Loader } from 'rsuite';
import Select from 'react-select';

export const tooltip = (
    <Tooltip className='show calling-script-tooltip'>
        {`Optional variables available: Supplier Name, Partner Name and Customer Name. You can add these variables by typing @.`}
    </Tooltip>
);

const CreateCallingScriptComponent = ({
    onShowCreateCallingScript,
    partnerId = null,
    partnerName = '',
    defaultScript,
    isFromPartnerManage = false,
    isUpdatingPartner = false,
    onCreateScript,
    onChangeCallingScriptInfo,
    scriptDetail = {},
    isDefaultId,
    isUpdatingScript = false,
    handleClose,
    setScriptInfo,
    isDisable,
    newPartnerId,
    partnerPage
}) => {
    const store = useStore().getState();
    const dispatch = useDispatch();
    const history = useHistory();
    const userSuggestion = [
        { text: 'Supplier name', value: 'suppliername' },
        { text: 'Partner name', value: 'partnerName' },
        { text: 'Company name', value: 'companyName' },
        { text: 'Contact name', value: 'contactName' }
    ];
    let isDisabled = false;

    if (partnerPage === 'create' && newPartnerId === null) {
        isDisabled = true;
    }

    useEffect(() => {
        !isFromPartnerManage && history.push('/upload/create-calling-script');
    }, [history, isFromPartnerManage]);

    const [isCreating, setIsCreating] = useState(false);
    const [callingScriptInfo, setCallingScriptInfo] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [isChangeDefaultScript, setIsChangeDefaultScript] = useState(false);
    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());
    const [isLoading, setIsLoading] = useState(false);
    const [selectedScriptType, setSelectedScriptType] = useState({});

    const setInitialScriptInfoHandler = (scriptDetail) => {
        if (isUpdatingScript) {
            setCallingScriptInfo({
                ...callingScriptInfo,
                title: scriptDetail?.title,
                isDefault: scriptDetail?.isDefault,
                isReenablement: scriptDetail?.isReenablement
            });
            
            if (partnerName === 'Ricochet') {
                const scriptType = scriptDetail?.isDefault 
                    ? { label: 'Default Script', value: 'default' }
                    : { label: 'Reenablement Script', value: 'reenablement' };
                setSelectedScriptType(scriptType);
            }
            
            setEditorState(EditorState.createWithContent(
                ContentState.createFromBlockArray(convertFromHTML(scriptDetail?.script))
            ));
        }
    };

    useEffect(() => {
        setInitialScriptInfoHandler(scriptDetail);
    }, [isUpdatingScript, scriptDetail]);

    const handleCancelCallingScript = () => {
        setCallingScriptInfo({});
        setEditorState(EditorState.createEmpty());
    };

    const handleCancelUpdateCallingScript = () => {
        setInitialScriptInfoHandler(scriptDetail);
    };

    const handleYesClick = () => {
        setIsChangeDefaultScript(true);
        setShowPopup(false);
    };

    const handleNoClick = () => {
        setShowPopup(false);
        setIsChangeDefaultScript(false);
        setCallingScriptInfo({
            ...callingScriptInfo,
            isDefault: false
        });
    };

    const updateTextDescription = (state) => {
        setEditorState(state);
    };

    const handleChangeCallingScriptInfo = (colName, value) => {
        if (colName === 'isDefault') {
            if (value === true) {
                if (isFromPartnerManage || isUpdatingPartner) {
                    setShowPopup(true);
                }
            } else {
                setIsChangeDefaultScript(value);
            }
        } else if (colName === 'isScriptOption') {
            setSelectedScriptType(value);
            if (value.value === 'default') {
                setShowPopup(true);
            }
        }
        
        setCallingScriptInfo({
            ...callingScriptInfo,
            [colName]: value
        });

        if (isFromPartnerManage && !isUpdatingPartner) {
            onChangeCallingScriptInfo({
                ...callingScriptInfo,
                [colName]: value
            });
        }
    };

    const getScriptContent = () => {
        const editorContent = draftToHtml(convertToRaw(editorState.getCurrentContent()));
        const removeAnchor = editorContent.replaceAll(/<a.*?>/g, "");
        const removeAnchorClose = removeAnchor.replaceAll(/<\/a>/g, "");
        return removeAnchorClose;
    };

    const handleCreateCallingScript = () => {
        const isEmpty = convertToRaw(editorState.getCurrentContent()).blocks.every(block => block.text.trim() === '');
    
        if (!callingScriptInfo?.title) {
            toast.show({
                title: 'Warning',
                description: "Script title shouldn't be empty!",
            });
            return;
        }
        if (isEmpty) {
            toast.show({
                title: 'Warning',
                description: "Calling script shouldn't be empty!",
            });
            return;
        }
    
        setIsCreating(true);
        const scriptContent = getScriptContent();
        
        const payload = {
            title: callingScriptInfo.title,
            script: scriptContent,
            partnerId: newPartnerId !== null ? newPartnerId : partnerId,
            previousDefaultId: defaultScript?.id || null
        };
    
        if (partnerName === 'Ricochet') {
            payload.isDefault = selectedScriptType.value === 'default';
            payload.isReenablement = selectedScriptType.value === 'reenablement';
        } else {
            payload.isDefault = Boolean(callingScriptInfo.isDefault);
            payload.isReenablement = false;
        }
    
        dispatch(createCallingScript(payload))
            .then(res => {
                toast.show({
                    title: 'Success',
                    description: res.message
                });
                setCallingScriptInfo({});
                setEditorState(EditorState.createEmpty());
                !isFromPartnerManage && onShowCreateCallingScript(false);
                isFromPartnerManage && onCreateScript(res.script);
                setIsCreating(false);
            })
            .catch(err => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed to create calling script!'
                });
                setIsCreating(false);
            });
    };

    const editCallingScriptHandler = () => {
        const isEmpty = convertToRaw(editorState.getCurrentContent()).blocks.every(block => block.text.trim() === '');

        if (!callingScriptInfo?.title) {
            toast.show({
                title: 'Warning',
                description: "Script title shouldn't be empty!",
            });
            return;
        }
        if (isEmpty) {
            toast.show({
                title: 'Warning',
                description: "Calling script shouldn't be empty!",
            });
            return;
        }

        setIsLoading(true);
        const scriptDetails = {
            title: callingScriptInfo.title,
            script: getScriptContent()
        };

        // Set the correct flags based on partner type
        if (partnerName === 'Ricochet') {
            scriptDetails.isDefault = selectedScriptType.value === 'default';
            scriptDetails.isReenablement = selectedScriptType.value === 'reenablement';
        } else {
            scriptDetails.isDefault = Boolean(callingScriptInfo.isDefault);
            scriptDetails.isReenablement = false;
        }

        dispatch(editCallerScriptOfPartner(
            partnerId,
            scriptDetail?.id,
            isChangeDefaultScript,
            scriptDetails,
            isDefaultId
        )).then((res) => {
            setIsLoading(false);
            onCreateScript();
            handleClose();
        }).catch((err) => {
            setIsLoading(false);
            toast.show({
                title: 'Warning',
                description: 'Failed to update script!'
            });
        });
    };

    return (
        <div className={`create-calling-script-page ${!isFromPartnerManage ? ' padding-left' : ''}`}>
            {!isFromPartnerManage && (
                <div className='current-page-title d-flex align-items-center gap-3'>
                    <MdOutlineArrowBackIosNew color="#78B1E4" size={16} onClick={() => { onShowCreateCallingScript(false) }} />
                    Create Calling Script
                </div>
            )}
            <div className={`partner-management-content mt-4 position-relative${(isCreating && !isUpdatingScript) ? ' loading' : ''}`}>
                {(isCreating && !isUpdatingScript) && <LoaderComponent />}
                <div className='calling-script border rounded mt-5 bg-white'>
                    <div className='header d-flex gap-2 align-items-center p-3 border border-top-0 border-end-0 border-start-0'>
                        <h3 className='mb-0 text-blue fw-bold'>{isUpdatingScript ? "Edit Script" : "Calling Script"}</h3>
                        <Whisper placement="rightStart" controlId="control-id-hover" trigger="hover" speaker={tooltip}>
                            <AiOutlineInfoCircle color='#78B1E4' size={24} />
                        </Whisper>
                        <div className='ms-auto d-flex gap-2'>
                            <button
                                className='width-100 h4 mb-0 pt-3 pb-3 bg-light-gray text-white rounded'
                                onClick={isUpdatingScript ? handleCancelUpdateCallingScript : handleCancelCallingScript}
                            >
                                Cancel
                            </button>
                            <button
                                className='width-100 h4 mb-0 pt-3 pb-3 btn-green rounded'
                                disabled={(isUpdatingScript && isLoading) || (isDisabled || isLoading)}
                                onClick={isUpdatingScript ? editCallingScriptHandler : handleCreateCallingScript}>
                                {(isUpdatingScript && isLoading) ? <Loader /> : isUpdatingScript ? "Update" : "Create"}
                            </button>
                        </div>
                    </div>
                    <div className='content d-flex gap-4 p-4 flex-column'>
                        <div className='d-flex gap-5'>
                            <div className='d-flex flex-grow-1 align-items-center'>
                                <h4 className='mb-0 text-black fw-bold w-25'>Script Title</h4>
                                <input
                                    className='search-input h4 mb-0'
                                    value={callingScriptInfo?.title || ''}
                                    onChange={(e) => { handleChangeCallingScriptInfo('title', e.target.value); }}
                                />
                            </div>
                            {partnerName === 'Ricochet' ? (
                                <div className='d-flex flex-grow-1 align-items-center'>
                                    <h4 className={`mb-0 text-black fw-bold ${isUpdatingScript ? "w-50" : "w-25"}`}>Script Type</h4>
                                    <Select
                                        className="w-100 h4 mb-0 text-black"
                                        options={[
                                            {
                                                label: 'Reenablement Script',
                                                value: 'reenablement',
                                            },
                                            {
                                                label: 'Default Script',
                                                value: 'default',
                                            },
                                        ]}
                                        value={selectedScriptType}
                                        onChange={(option) => {
                                            handleChangeCallingScriptInfo('isScriptOption', option);
                                        }}
                                    />
                                </div>
                            ) : (
                                <div className='d-flex flex-grow-1 align-items-center'>
                                    <h4 className={`mb-0 text-black fw-bold ${isUpdatingScript ? "w-50" : "w-25"}`}>Default Script</h4>
                                    <CheckboxComponent
                                        checked={callingScriptInfo?.isDefault || false}
                                        onChange={(checked) => { handleChangeCallingScriptInfo('isDefault', checked); }}
                                    />
                                </div>
                            )}
                        </div>
                        <div className='d-flex flex-grow-1 border rounded p-2'>
                            <div className='calling-script-editor-parent w-100 filter-component-parent' style={{ zIndex: 0 }}>
                                <Editor
                                    editorState={editorState}
                                    toolbarClassName={`scalling-script-editor-toolbar hide`}
                                    wrapperClassName="calling-script-editor-wrapper flex"
                                    editorClassName="calling-script-editor h5 w-100 overflow-visible"
                                    onEditorStateChange={updateTextDescription}
                                    mention={{
                                        separator: ' ',
                                        trigger: '@',
                                        suggestions: userSuggestion,
                                    }}
                                    placeholder='Write script...'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal backdrop={'static'} className={`position-relative`} show={showPopup} onHide={handleNoClick}>
                <Modal.Header>
                    <Modal.Title className='fw-bold text-black'>
                        Change Default Script
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='d-flex flex-column align-items-center'>
                    <h4 className='mb-0 text-black fw-bold'>Are you sure you want to update the {partnerName === 'Ricochet' ? selectedScriptType?.label : 'default'} script for partner {partnerName}?</h4>
                    <div className='mt-4'>
                        <button className='me-3 pt-2 pb-2 h4 mb-0 fw-bold rounded bg-red text-white width-100' onClick={handleNoClick}>No</button>
                        <button className='pt-2 pb-2 h4 mb-0 fw-bold rounded btn-green text-white ms-auto width-100' onClick={handleYesClick}>Yes</button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default CreateCallingScriptComponent;